import { normalEvent_NewMap } from "../manager/DefineInterface";

let event_NewMap:normalEvent_NewMap = null;

export default function normalEvents_New(){
    if(!event_NewMap){
        event_NewMap = {
            
        }
    }
    return event_NewMap;
}

//从人才市场出来触发的事件id
let marketEventAry:string[] = [];

//从公园出来触发的事件id
let parkEventAry:string[] = [];

//从按摩店出来触发的事件id
let kneadEventAry:string[] = [];

export function getOneNormalEventNewById(id : string | number){
    return normalEvents_New()[id];
}

export function getMarketEventAry(){
    return marketEventAry;
}

export function getparkEventAry(){
    return parkEventAry;
}

export function getkneadEventAry(){
    return kneadEventAry;
}
